import { useCallback, useState } from "react";
import { Assessment } from "../../../models/Assessment";
import AssessmentRepository from "../../../repositories/AssessmentRepository";

export const useGetAssessments = () => {
  const [data, setData] = useState<Assessment[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const loadData = useCallback(async (params: any = {}) => {
    setIsLoading(true);

    if (!params?.order_by) {
      Object.assign(params, {
        order_by: "priority",
        sorted_by: "asc",
      });
    }

    await AssessmentRepository.findAll({
      ...params,
      is_active: 1,
      with: ["photo"],
    })
      .then((response) => {
        const { data: responseData } = response.data;
        setData(responseData);
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return {
    data,
    isLoading,
    loadData,
  };
};
